module.exports = __webpack_public_path__ + "img/exchange1.066ac857.jpg";